<script>
import Slick from "vue-slick";
import VueScrollTo from "vue-scrollto";

export default {
  data() {
    return {
      slickOptions: {
        //options can be used from the plugin documentation
        slidesToShow: 1,
        infinite: false,
        accessibility: true,
        adaptiveHeight: window.innerWidth < 768 ? true : false,
        arrows: true,
        dots: true,
        draggable: false,
        edgeFriction: 0.3,
        swipe: true
      }
    };
  },
  methods: {
    handleInit(event, slick) {
      slick.$dots.append('<li class="count-max">' + slick.slideCount + "</li>");
      document.getElementById("scrollTrigger").click();
    }
  },
  components: {
    slick: Slick
  }
};
</script>

<template>
  <article id="article_usarmi" class="do-article">
    <a class="hidden" id="scrollTrigger" v-scroll-to="{ el: '#article_usarmi', duration: 1 }"></a>
    <div class="row no-gutters">
      <div class="col-xl-4 col-lg-5">
        <div class="do-article-info">
          <progressive-background src="static/images/article2.jpg"/>
          <h2>PAURA DI USARMI?</h2>
          <p>
            La <strong>plastica è fondamentale</strong> nella nostra <strong>vita quotidiana</strong>. Sono innumerevoli i motivi per i quali non potresti <strong>farne a meno</strong>. 
          </p>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7">
        <div class="do-article-content">
          <router-link class="do-back" to="/">
            <img src="static/images/back.svg" alt="Go Back">
          </router-link>

          <div class="do-article-slider">
            <slick ref="slick" :options="this.slickOptions" @init="handleInit">
              <!-- Slide -->
              <div class="do-slide">
                <div class="row align-content-start mt-4 h-100">
                  <div class="col-12">
                    <h3>SALUTE</h3>
                  </div>
                  <div class="col-xl-10 col-lg-12 col-md-10">
                    <p>
                      In medicina la plastica è <strong>indispensabile</strong>.
                      Siringhe, lenti a contatto, capsule, cateteri, contenitori per i fluidi, i nuovi ausili medicali per restituire funzionalità al cuore, alle articolazioni, ai reni, alle orecchie, ai denti e agli occhi, sono possibili grazie alla plastica.
                      Quando si parla di salute la <strong>plastica</strong> dimostra di essere il <strong>materiale ideale</strong>, garantendo <strong>sicurezza</strong>, <strong>igiene</strong> e <strong>bio-compatibilità</strong> con il corpo umano.
                    </p>
                  </div>
                  <div class="col-xl-8 col-lg-12 col-md-8">
                    <p>
                      Le materie plastiche sono anche una <strong>componente necessaria</strong> dei <strong>macchinari</strong> utilizzati negli <strong>ospedali</strong> o per la <strong>ricerca medica</strong>.
                    </p>
                    <p>
                      Sono facili da pulire e <strong>sterilizzare</strong> e hanno naturali proprietà di barriera contro fluidi, gas e agenti inquinanti. Ad esempio, i pavimenti realizzati in plastica, assicurano un efficace mantenimento dell’<strong>igiene</strong>.
                      Le fibre polimeriche vengono impiegate nelle <strong>fasciature chirurgiche</strong> mentre componenti in plastica sono spesso utilizzate per isolare le aree a rischio di malattie infettive.
                    </p>
                  </div>
                  <div class="col-xl-4 col-lg-12 col-md-4 d-flex align-items-center mb-4">
                    <img class="w-100 mw-260 mh-180" src="static/images/article2-img1.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
                            <!-- Slide -->
              <div class="do-slide">
                <div class="row align-content-start mt-4 h-100">
                  <div class="col-12">
                    <h3>ALIMENTARE</h3>
                  </div>
                  <div class="col-xl-8 col-lg-12 col-md-8"> 
                    <p>
                      La <strong>plastica</strong> ha un ruolo <strong>determinante</strong> nell’<strong>industria alimentare</strong>. 
Gli <strong>imballaggi</strong> proteggono gli <strong>alimenti</strong> da qualsiasi tipo di <strong>contaminazione</strong> e rappresentano una <strong>barriera</strong> contro microbi, umidità, radiazioni UV e danni fisici. 
                    La <strong>durata</strong> dei <strong>cibi</strong> viene <strong>prolungata</strong> fino ad essere addirittura <strong>triplicata</strong>. Un esempio? 10 grammi di un film multistrato aumentano il periodo di conservazione della <strong>carne</strong> da alcuni giorni a <strong>oltre una settimana</strong>.
                    </p>
                  </div>
                  <div class="col-lg-8">  
                    <p>
                      La plastica <strong>riduce gli sprechi alimentari</strong>: gli imballaggi di plastica sono <strong>semplici da aprire</strong>, <strong>utilizzare</strong> e <strong>sigillare</strong>. 
La plastica aumenta la <strong>leggerezza</strong> dei prodotti: se si sostituisse con altri materiali si registrerebbe un aumento di peso degli imballaggi di quasi <strong>4 volte</strong>, causando di conseguenza un aumento del traffico per il trasporto delle merci di circa il <strong>50%</strong>.
                    </p>
                  </div>
                  <div class="col-lg-4 my-4">
                    <img class="w-100 mw-260 mh-180 mt-auto" src="static/images/article2-img6.png" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row align-content-start mt-4 h-100">
                  <div class="col-12">
                    <h3>SPORT</h3>
                  </div>
                  <div class="col-xl-8 col-lg-12 col-md-8">
                    <p>
<strong>Sport</strong> e <strong>plastica</strong> sono una <strong>squadra vincente</strong>.
                      Grazie a continue <strong>ricerche</strong> le plastiche hanno rivoluzionato molte <strong>discipline sportive</strong> e il nostro <strong>tempo libero</strong>.
                      La <strong>plastica</strong> è utilizzata per <strong>produrre</strong> quasi tutti i tipi di <strong>palloni</strong>, grandi o piccoli, veloci o lenti, morbidi o duri, rigidi o flessibili. Sono di
plastica quelli da calcio, da basket, da rugby, le palle da golf, da tennis, da biliardo e da bowling.
                    </p>
                    
                  </div>
                  <div class="col-xl-8 col-lg-12 col-md-8">
                    <p>
                      Le <strong>materie plastiche</strong> sono utilizzate per la <strong>produzione</strong> di <strong>calzature</strong> e altri <strong>capi d’abbigliamento</strong> che garantiscono <strong>elevate prestazioni</strong> per corsa, salto, escursionismo, arrampicata e boxe.
                    </p>
                    <p>
                      Altri esempi? Le <strong>racchette da tennis</strong>, realizzate in compositi speciali, superano quelle in qualsiasi altro materiale perché sono <strong>leggere</strong>, resistenti e riducono le <strong>vibrazioni</strong> da <strong>urto</strong> del <strong>45%</strong>.
                    </p>
                    <p>
                      Le biciclette da corsa con i telai in fibra di carbonio pesano soltanto 6,8 kg pur assicurando resistenza e stabilità senza pari.
                    </p>
                  </div>
                  <div class="col-xl-4 col-lg-12 col-md-4 d-flex align-items-center mb-4">
                    <img class="w-100 mw-260 mh-180" src="static/images/article2-img2.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row align-content-start mt-4 h-100">
                  <div class="col-10">
                    <h3>ENERGIA</h3>
                    <p>
                      La plastica è necessaria per
                      <strong>sfruttare al meglio l’energia solare</strong>. Molte parti dei
                      <strong>pannelli fotovoltaici</strong>, come ad esempio l’alloggiamento del collettore, il tubo di isolamento o il sistema di controllo centrale, sono infatti composte da materiali plastici.
                    </p>
                    <p>Le plastiche si trovano anche nelle pale dei rotori per le turbine eoliche e nei tubi che alimentano le centrali idroelettriche.</p>
                  </div>
                  <div class="col-12 my-4">
                    <img class="w-100 mw-260 mh-180" src="static/images/article2-img3.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row align-content-start mt-4 h-100">
                  <div class="col-10">
                    <h3>TRASPORTI</h3>
                    <p>
                      La plastica è vincente nell’<strong>industria dei trasporti</strong>: è poco costosa, offre comfort, <strong>sicurezza</strong> ed <strong>efficienza energetica</strong>.
                      L’utilizzo di <strong>imballaggi di plastica</strong> consente di <strong>ridurre</strong> il numero dei <strong>mezzi di trasporto</strong> su strada, con conseguente <strong>riduzione di CO<sub>2</sub></strong>. 
                      Lo stesso quantitativo di prodotto, se imballato con altri materiali, peserebbe di più generando un maggior impatto ambientale, oltre a costi di spedizione decisamente più elevati.
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-12 col-md-6">
                    <p>
                      I materiali plastici migliorano le prestazioni strutturali rendendo le <strong>automobili</strong> più <strong>sicure</strong>, più resistenti agli impatti e più economiche.
                    </p>
                    <p>Le componenti in plastica nelle auto pesano circa il <strong>50% in meno</strong> di quelle realizzate con altri materiali e consentono di avere:
                    </p>
                    <ul>
                      <li>
                        <strong>veicoli più sicuri, più leggeri</strong> e con un <strong>minore consumo</strong> di <strong>carburante</strong>
                      </li>
                      <li>
                        <strong>emissioni ridotte</strong>
                      </li>
                      <li>
                        <strong>riduzione di rumori, rigidità e vibrazioni</strong>
                      </li>
                    </ul>
                  </div>
                  <div class="col-xl-6 col-lg-12 col-md-6">
                    <p>
                      Negli <strong>aerei</strong> le plastiche vengono utilizzate per porte, finestrini, sedili e rifiniture d’interni, timoni e stabilizzatori, ali, flap, spoiler e pneumatici, determinando un sensibile <strong>risparmio</strong> di <strong>carburante</strong> per ogni volo. 
                    </p>
                    <p>
                      I <strong>treni</strong> sono più <strong>veloci</strong> e <strong>silenziosi</strong> grazie alla leggerezza dei materiali plastici e alla facilità con cui è possibile modellarli in strutture aerodinamiche.
                    </p>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row align-content-start mt-4 h-100">
                  <div class="col-10">
                    <h3>EDILIZIA</h3>
                    <p>
                      I costruttori utilizzano i <strong>prodotti</strong> di <strong>plastica</strong> perché sono duraturi, leggeri, convenienti e piacevoli dal punto di vista estetico. La <strong>manutenzione</strong> delle plastiche, rispetto a quella di altri materiali, è più <strong>vantaggiosa</strong> anche dal punto di vista economico: resistono alla corrosione, hanno elevate <strong>proprietà di isolamento</strong> e sono facili da pulire.
                    </p>
                  </div>
                  <div class="col-12 my-4">
                    <img class="w-100 mw-260 mh-180" src="static/images/article2-img5.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
            </slick>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>



// WEBPACK FOOTER //
// src/components/Usarmi.vue